import { Observable } from 'rxjs';
import { Association, DisclaimersApi, UpsertDisclaimerRequest } from 'src/app/hickory-api';
import { mockHandler } from '../mock.handler';

export class MockDisclaimersApi extends DisclaimersApi {

  disclaimerContent = 'Use at your own risk!';
  associations: Association[] = null;

  getDisclaimer(): Observable<any> {
    return mockHandler({ item: { content: { data: this.disclaimerContent }, associations: this.associations } });
  }

  updateDisclaimer(updateDisclaimerRequest: UpsertDisclaimerRequest): Observable<any> {
    this.disclaimerContent = updateDisclaimerRequest.htmlContent;
    this.associations = updateDisclaimerRequest.associations;
    return mockHandler({});
  }

  deleteDisclaimer(): Observable<any> {
    this.disclaimerContent = this.associations = null;
    return mockHandler({});
  }
}
